import React from 'react';
import _ from 'lodash';
import Joi from 'joi-browser';

import CommonModal from '../components/modals/common/Modal';
import { RadioButtonIcon } from '../components/icons/RadioButtonIcon';
import InfinityScrollLoad from '../components/InfinityScrollLoad';
import Confirmation from '../components/modals/common/Confirmation';
import PartnerCompanyRegisterConfirmDialog from '../components/PartnerCompanyRegisterConfirmDialog';
import Tippy, { ToolTip } from '../components/ReactTippy';
import { Tel } from '../components/Tel';
import { CompanyService } from '../services/Companies';
import FieldApi from '../services/field/FieldApi';
import FieldTreesApi from '../services/fieldTrees/FieldTreesApi';
import FieldTreeService from '../services/FieldTrees';
import PrincipalIcon from '../images/icon/icon--principal.svg';
import {
  AGENCY_REGISTRATION_APPLICATION_STATUS,
  API_FLAG,
  JOINING_FLAG,
  ONE_MASTER_FLAG,
  PREFECTURE_LISTS,
  PREFECTURE_GROUPS,
  FIELD_WORK_HOUR_ZONES,
  CALL_FROM_PAGE,
} from '../utilities/constants';
import { messageUtility } from '../utilities/messageUtility';
import { isNullOrEmpty, maskTel } from '../utilities/stringUtil';
import {
  isPartnerRoleId,
  isPrimaryCompanyRoleId,
} from '../utilities/roleUtility';
import regex from '../utilities/validateRegex';
import { validateByJoi } from '../utilities/validation';
import masterSlideLoader from '../utilities/masterSlideLoader';
import EventMg from '../utilities/EventManager';
import { FIELD_TREE_EVENTS } from '../components/FieldTreeEvents';
import { FormInput } from './FormInput';
import { FormSelect } from './FormSelect';
import {
  loadFromPartnerCompanies,
  loadFromFieldTreePage,
  loadFromAgencyRegister,
} from '../utilities/partnerCompanyRegisterUtil';
import LocalStorageService from '../services/utilities/LocalStorageService';
import { Description } from './Description';
import { Information } from './modals/common';
import SessionStorageService from '../services/utilities/SessionStorageService';

export class PartnerCompanyAddDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formValues: {
        field_id: '',
        parent_tree_id: '',
        company_branch_id: '',
        prime_contractors_company_branch_id: '',
        representative: '',
        private_partner_company_flag: 0,
      },
      confirmValues: {
        company: {},
        branch: {},
      },
      data: [],
      param: {
        city_name: '',
        name_kana: '',
        company_number: '',
        prefectures_code_id: '',
        tel: '',
        is_agent_to: 0, // 代行先の会社のみ表示
        offset: 0,
        one_master_flag: '',
      },
      cacheParam: {}, // 検索時点でのパラメーター
      noSelectedCompany: false,
      prime_company_name: '', // 元請会社名
      searchIsOpen: true,
      searchWithCorporate: false,
      selected: null,
      cacheSlected: null,
      selectedBranch: null,
      selectedKey: null, // 協力会社一覧の項目index(表示選択用)
      showDuplicateDialog: false,
      showConfirmDialog: false,
      showCheckPartnerCompanyDialog: false,
      similarCompanyExists: false,
      total: 0,
      messages: {}, // 検索フォームエラーメッセージ格納用オブジェクト
      validate: '',
      createCompanyFlag: false, // 新規登録フラグ
      isLoading: false,
      noDataMessage: messageUtility.getMessage('I-000-134'),
      workHourZoneSetting: {},
      isPartners: false,
      addDuplicateCompany: false,
      tableHeight: '100%',
      validationMessage: '',
      showWarningCreateCompany: false,
    };
    this.tableDescriptionRef = React.createRef();
    this.searchingFlag = false; // 連打防止用の検索途中を示すフラグ
    this.isSelectingCompany = false; // 連打防止用の重複会社確認中を示すフラグ
    this.isCreatingCompany = false;
    this.events = {
      form: {
        close: this.closeConfirm,
        confirmCreatePartnerCompany: this.confirmCreatePartnerCompany,
        handleConfirmInput: this.handleConfirmInput,
        submit: this.submit,
        redirectFieldTree: this.redirectFieldTree,
        redirectPartnerCompanies: this.redirectPartnerCompanies,
        resetUpdatingFlag: this.resetUpdatingFlag,
      },
    };
    if (
      _.has(props, 'dialog.state.similarCompanyExists') &&
      this.props.dialog.state.similarCompanyExists
    ) {
      this.state.similarCompanyExists = true;
      this.state.noDataMessage = '';
    }

    this.schema = Joi.object().keys({
      company_number: Joi.string()
        .label('company_number')
        .regex(regex.pattern.company_number)
        .allow(null, ''),
      tel: Joi.string()
        .label('tel')
        .regex(regex.pattern.tel)
        .allow(null, '', '--'), // 電話番号
    });

    this.companyId = SessionStorageService.getCompanyId();
    this.roleId = LocalStorageService.getRoleId();
  }

  /**
   * 連打防止フラグをリセットする
   */
  resetUpdatingFlag = () => {
    if (
      this.props.dialog.callback.resetUpdatingFlag &&
      _.isFunction(this.props.dialog.callback.resetUpdatingFlag)
    ) {
      this.props.dialog.callback.resetUpdatingFlag();
    }
  };

  handleConfirmInput = (value, key) => {
    this.setState(
      {
        formValues: {
          ...this.state.formValues,
          [key]: value,
        },
      },
      () => {
        if (
          key !== 'representative' &&
          key !== 'private_partner_company_flag'
        ) {
          this.validate();
        }
      }
    );
  };

  closeConfirm = () => {
    this.setState({
      showConfirmDialog: false,
      validate: '',
    });
  };

  redirectFieldTree = () => {
    this.closeConfirm();
    this.props.dialog.callback.close();

    EventMg.trigger(FIELD_TREE_EVENTS.TREE_REFRESH);
    masterSlideLoader.show(
      'FieldTreePage',
      { state: { id: 1 } },
      this.props.vw
    );
    EventMg.trigger(FIELD_TREE_EVENTS.BACK_TO_MAIN, {
      update: true,
    });
  };

  redirectPartnerCompanies = () => {
    this.closeConfirm();
    this.props.dialog.callback.close();
    masterSlideLoader.show(
      'PartnerCompanies',
      { state: { id: 1 } },
      this.props.vw
    );
  };

  checkForPreviousSearch = async () => {
    // cacheParamをチェックしてparamなどに入れる
    if (!_.has(this.props.dialog.state.options, 'cacheParam')) {
      // 初期表示・再検索しない
      return false;
    } else {
      const cacheParam = this.props.dialog.state.options.cacheParam;
      // 法人番号以外に入力がある場合は「個人事業主」側のラジオボタンを表示する
      const inputsWithoutCompanyNumber = _.omit(cacheParam, 'company_number');
      if (
        _.some(inputsWithoutCompanyNumber, input => {
          return !_.isEmpty(input);
        })
      ) {
        this.setState({
          param: cacheParam,
          cacheParam,
          searchWithCorporate: false,
          searchIsOpen: true,
        });
      } else {
        // 法人番号で検索するタブ
        if (!_.isEmpty(cacheParam.company_number)) {
          this.setState({
            param: cacheParam,
            cacheParam,
            searchWithCorporate: true,
            searchIsOpen: true,
          });
        }
      }
    }
    return true;
  };

  /**
   * 協力会社一覧を取得する
   *
   * @param {function}notifyEnd: 無限スクロール終了通知
   * */
  fetchPartnerCompany = async notifyEnd => {
    // 無限スクロールからのcallbackで、すでに全件取得済みの場合には追加リクエストせず無限スクロール終了
    if (notifyEnd && this.state.data.length >= this.state.total) {
      notifyEnd('end');
      return;
    }
    this.setState({ isLoading: true });
    if (this.searchingFlag) {
      return;
    }
    this.searchingFlag = true;
    let param, response;
    if (this.state.similarCompanyExists) {
      param = this.createSearchSimilarityParam();
      response = await CompanyService.similarityCompany(param);
    } else {
      param = this.createSearchParam();

      // 元請ユーザで所属会社IDと違うJVを施工体系図から選んだ場合、協力会社一覧は表示しない
      if (
        param.call_from === CALL_FROM_PAGE.FIELD_TREE_PAGE &&
        _.has(this.props, 'dialog.jvCompanyId') &&
        this.hideUsageStatus() &&
        isPrimaryCompanyRoleId(this.roleId) &&
        param.emptySearch
      ) {
        this.setState({ isLoading: false }, () => {
          this.searchingFlag = false;
        });
        return;
      }
      response = await FieldTreesApi.fetchPartnerCompanyList(param);
    }
    this.setState({ isLoading: false });
    this.searchingFlag = false;

    if (response.result) {
      const total = response.data.total;
      const prime_company_name = response.data.prime_company_name;
      let noDataMessage;
      if (total === 0) {
        if (this.canCreateCompany()) {
          noDataMessage = messageUtility.getMessage('I-000-132');
        } else {
          noDataMessage = messageUtility.getMessage('I-000-267');
        }
      } else {
        noDataMessage = messageUtility.getMessage('I-000-134');
      }
      this.setState({ noDataMessage });
      if (_.has(response, 'data.entities.companies')) {
        const newData = [
          ...this.state.data,
          ...response.data.entities.companies,
        ];

        this.setState(
          {
            total,
            data: newData,
            prime_company_name,
          },
          () => {
            if (notifyEnd) {
              notifyEnd();
            }
          }
        );
      } else {
        if (notifyEnd) {
          notifyEnd();
        }
      }
    } else {
      // TODO エラー内容をダイアログ表示する
      console.error(response);
    }
  };

  /**
   * 検索パラメータを作成する
   * @return {object} 検索パラメータ
   * */
  createSearchParam = () => {
    let param = {};
    param.offset = this.state.data.length;
    param.include_outers = 0;
    param.emptySearch = true;
    param.selected_jv_company_id = this.props.dialog.jvCompanyId;

    if (this.fromFieldTreePage()) {
      param.call_from = CALL_FROM_PAGE.FIELD_TREE_PAGE;
    }

    if (this.fromAgencyRegister()) {
      param.agency_flag = true;
      param.include_outers = 1;
    }

    if (
      this.state.searchWithCorporate &&
      this.state.cacheParam.company_number
    ) {
      param.emptySearch = false;

      // 法人番号で検索する場合
      param.company_number = this.state.cacheParam.company_number;
      // 法人番号を入力した場合には自社または元請会社に紐づかない協力会社も表示する
      // 二次請以降の協力会社の場合は、国税庁法人マスタにしかない会社は表示しない
      if (this.canCreateCompany()) {
        param.include_outers = 1;
      } else if (
        !this.state.similarCompanyExists &&
        this.fromFieldTreePage() &&
        !this.canProxyRegister()
      ) {
        param.include_outers = 1;
        param.not_kokuzei_flag = true;
      }
    } else {
      if (this.state.cacheParam.name_kana) {
        // 会社名・屋号・氏名ふりがな
        param.name_kana = this.state.cacheParam.name_kana;
      }
      if (this.state.cacheParam.tel) {
        // 電話番号
        param.tel = this.state.cacheParam.tel;
      }
      if (this.state.cacheParam.prefectures_code_id) {
        // 都道府県名
        param.prefecture_name =
          PREFECTURE_LISTS[this.state.cacheParam.prefectures_code_id];
      }
      if (this.state.cacheParam.city_name) {
        // 市区町村名
        param.city_name = this.state.cacheParam.city_name;
      }
      if (this.state.cacheParam.is_agent_to) {
        // 代行先の会社のみを表示
        param.is_agent_to = this.state.cacheParam.is_agent_to;
      }
      if (this.state.cacheParam.one_master_flag) {
        param.one_master_flag = this.state.cacheParam.one_master_flag;
      }

      if (
        param.name ||
        param.name_kana ||
        param.tel ||
        param.prefecture_name ||
        param.city_name ||
        param.is_agent_to ||
        param.one_master_flag
      ) {
        param.emptySearch = false;

        // なんらかの検索条件がある場合には元請会社に紐づかない協力会社も表示する
        // 二次請以降の協力会社の場合は、国税庁法人マスタにしかない会社は表示しない
        if (this.canCreateCompany()) {
          param.include_outers = 1;
        } else if (
          !this.state.similarCompanyExists &&
          this.fromFieldTreePage() &&
          !this.canProxyRegister()
        ) {
          param.include_outers = 1;
          param.not_kokuzei_flag = true;
        }
      }
    }

    // 正しい利用実績取得のため施工体系では元請、協力会社ともに必要
    if (this.props.dialog.parentCompanyBranchId) {
      param.parent_company_branch_id = this.props.dialog.parentCompanyBranchId;
    }
    // 元請の場合はfieldTreeIdが0に設定されている
    if (this.props.dialog.fieldTreeId) {
      param.field_tree_id = this.props.dialog.fieldTreeId;
    }
    return param;
  };

  /**
   * 協力会社確認用の検索パラメータを作成する
   * @return {object} 検索パラメータ
   * */
  checkCompanyNumberParam = () => {
    let param = {};
    param.offset = 0;
    param.include_outers = 0;
    param.emptySearch = false;
    param.selected_jv_company_id = this.props.dialog.jvCompanyId;

    if (this.fromFieldTreePage()) {
      param.call_from = CALL_FROM_PAGE.FIELD_TREE_PAGE;
    }

    if (this.fromAgencyRegister()) {
      param.agency_flag = true;
      param.include_outers = 1;
    }
    if (this.canCreateCompany()) {
      param.include_outers = 1;
    } else if (
      !this.state.similarCompanyExists &&
      this.fromFieldTreePage() &&
      !this.canProxyRegister()
    ) {
      param.include_outers = 1;
      param.not_kokuzei_flag = true;
    }
    // 正しい利用実績取得のため施工体系では元請、協力会社ともに必要
    if (this.props.dialog.parentCompanyBranchId) {
      param.parent_company_branch_id = this.props.dialog.parentCompanyBranchId;
    }
    // 元請の場合はfieldTreeIdが0に設定されている
    if (this.props.dialog.fieldTreeId) {
      param.field_tree_id = this.props.dialog.fieldTreeId;
    }
    return param;
  };
  /**
   * 類似会社取得パラメータを作成する
   *
   * @return {object} 類似会社取得パラメータ
   * */
  createSearchSimilarityParam = () => {
    const company = this.props.dialog.state.company;
    const param = {
      parent_company_branch_id: this.props.dialog.parentCompanyBranchId,
      name: company.name,
      kana: company.kana,
      tel: company.tel,
      offset: this.state.data.length,
      call_from: CALL_FROM_PAGE.FIELD_TREE_PAGE,
      selected_jv_company_id: this.props.dialog.jvCompanyId,
    };

    if (this.fromAgencyRegister()) {
      param.agency_flag = true;
    }
    if (this.props.dialog.fieldTreeId !== 0) {
      // 元請会社の配下じゃない場合[fieldTreeId]も必要
      param.field_tree_id = this.props.dialog.fieldTreeId;
    }
    return param;
  };

  handleInput = (name, value) => {
    this.setState({
      param: {
        ...this.state.param,
        [name]: value,
      },
    });
  };

  /**
   * 検索方法を切り替える
   * */
  switchSearchMethod = event => {
    const state = _.cloneDeep(this.state);
    state.searchWithCorporate = !!Number(event.target.value);
    // 検索方法切り替え時に検索条件やエラーメッセージを初期化する
    state.messages = {};
    state.param = {
      city_name: '',
      name_kana: '',
      company_number: '',
      prefectures_code_id: '',
      tel: '',
      is_agent_to: API_FLAG.Off,
      one_master_flag: '',
    };
    state.validationMessage = '';
    this.setState(state);
  };

  toggleSearchOnlyAgency = () => {
    this.setState(
      prevState => ({
        param: {
          ...prevState.param,
          ['is_agent_to']:
            prevState.param.is_agent_to === API_FLAG.On
              ? API_FLAG.Off
              : API_FLAG.On,
        },
      }),
      () => {
        this.handleBlur('toggle_agency');
      }
    );
  };

  searchParamValidate = () => {
    return validateByJoi(this.schema, this.state.param);
  };

  /**
   * フォーカスアウト時のイベント制御
   * @param {string}key: フォーカスアウトイベント発火対象のキー名
   * */
  handleBlur = key => {
    const validateResult = this.searchParamValidate();
    let { messages, validationMessage } = _.cloneDeep(this.state);
    if (validateResult.result) {
      delete messages[key];
      validationMessage = '';
    }
    if (_.has(validateResult.messages, key)) {
      // バリデートエラーがあった場合
      messages[key] = validateResult.messages[key];
      validationMessage = messageUtility.getMessage('E-000-014'); // '入力エラーがあります。'
    }

    // 複合バリデーション
    // 住所の入力があり、氏名や電話番号の入力がない場合はエラー
    const param = this.state.param;
    if (
      (param.prefectures_code_id || param.city_name || param.one_master_flag) &&
      !param.name_kana &&
      !param.tel &&
      !param.is_agent_to
    ) {
      messages.address =
        '「会社名・屋号・氏名（かな検索可）」「電話番号」のいずれかも入力してください。';
      validationMessage = '検索条件を入力してください。';
    } else {
      delete messages.address;
    }
    // 氏名や電話番号の入力がない場合は「入力してください」エラーのみ表示する
    if (
      !param.company_number &&
      !param.name_kana &&
      !param.tel &&
      !param.is_agent_to
    ) {
      validationMessage = '検索条件を入力してください。';
    }

    this.setState({ messages, validationMessage });
  };

  /**
   * 検索条件をクリアする
   * */
  clearConditions = () => {
    if (this.fromFieldTreePage()) {
      if (this.searchingFlag) {
        return;
      }
    } else {
      this.searchingFlag = false;
    }
    this.setState(
      {
        data: [],
        param: {
          city_name: '',
          name_kana: '',
          company_number: '',
          prefectures_code_id: '',
          tel: '',
          is_agent_to: API_FLAG.Off,
          one_master_flag: '',
        },
        cacheParam: {},
        total: 0,
        selected: null,
        messages: {},
        noDataMessage: messageUtility.getMessage('I-000-134'),
        noSelectedCompany: false,
        validationMessage: '',
      },
      () => {
        if (this.fromFieldTreePage()) {
          this.fetchPartnerCompany();
        }
      }
    );
  };

  /**
   * 検索フォーム開閉処理
   * */
  searchFormOnOpen = () => {
    this.setState({
      searchIsOpen: !this.state.searchIsOpen,
    });
  };

  /**
   * 検索ボタン押下
   * */
  onSearchExecution = () => {
    const validate = this.searchParamValidate();
    const { param } = _.cloneDeep(this.state);

    if (!validate.result) {
      this.setValidationMessage(messageUtility.getMessage('E-000-014')); // '入力エラーがあります。'
      return; // 通常のバリデーションエラー
    }
    // 入力エラーがある
    if (_.has(validate, 'messages') && Object.keys(validate.messages).length) {
      this.setValidationMessage(messageUtility.getMessage('E-000-014')); // '入力エラーがあります。'
      return;
    }

    // 検索項目が全て未入力
    if (this.state.searchWithCorporate) {
      if (param.company_number === '') {
        this.setValidationMessage('検索条件を入力してください。');
        return;
      }
    } else {
      if (
        param.name_kana === '' &&
        param.company_number === '' &&
        param.tel === '' &&
        param.is_agent_to === API_FLAG.Off
      ) {
        this.setValidationMessage('検索条件を入力してください。');
        return;
      }
    }
    this.setState(
      {
        data: [],
        total: 0,
        selected: null,
        noSelectedCompany: false,
        cacheParam: {
          ...this.state.param,
        },
        validationMessage: '',
      },
      () => {
        this.fetchPartnerCompany();
      }
    );
  };

  setValidationMessage = validationMessage => {
    this.setState({ validationMessage });
  };

  getWorkHourZoneSetting = async () => {
    const response = await FieldApi.loadField(this.props.dialog.fieldId);
    if (response.result && _.has(response, 'data.entities.field')) {
      const field = response.data.entities.field;
      const workHourZone = {
        work_hour_zone_day_flag: field.work_hour_zone_day_flag === API_FLAG.On,
        work_hour_zone_night_flag:
          field.work_hour_zone_night_flag === API_FLAG.On,
        work_hour_zone_midnight_flag:
          field.work_hour_zone_midnight_flag === API_FLAG.On,
      };
      return workHourZone;
    }
    throw new Error('現場の作業時間帯設定の取得に失敗しました。');
  };

  //「選択した会社を追加・リストから追加」ボタンを押下
  selectCompany = async () => {
    if (this.isSelectingCompany) {
      return;
    }
    this.isSelectingCompany = true;

    if (_.isNull(this.state.selected)) {
      this.setState({ noSelectedCompany: true });
      this.isSelectingCompany = false;
      return;
    } else {
      const selected = _.mapValues(this.state.selected, value => {
        return _.isNull(value) ? '' : value;
      });
      if (!this.state.selected.id) {
        this.setState({ isLoading: true });
        if (this.searchingFlag) {
          return;
        }
        this.searchingFlag = true;
        let param, response;
        param = this.checkCompanyNumberParam();
        param.company_number = this.state.selected.company_number;
        response = await FieldTreesApi.fetchPartnerCompanyList(param);
        this.setState({ isLoading: false });
        this.searchingFlag = false;
        if (response.result) {
          const prime_company_name = response.data.prime_company_name;
          if (_.has(response, 'data.entities.companies')) {
            const newData = response.data.entities.companies[0];
            if (!_.isEqual(newData, this.state.selected)) {
              this.setState({
                cacheSlected: selected,
                selected: newData,
                prime_company_name,
              });
              this.showCheckPartnerCompanyDialog();
              return;
            }
          }
        } else {
          // TODO エラー内容をダイアログ表示する
          console.error(response);
        }
      }
      const cacheParam = _.cloneDeep(this.state.cacheParam);
      const options = _.cloneDeep(this.props.dialog.state.options);
      if (
        this.fromFieldTreePage() &&
        selected.buildee_use_flg &&
        !this.state.addDuplicateCompany
      ) {
        const isDuplicate = await this.checkDuplicate(
          this.props.dialog.fieldId,
          selected.company_branch_id,
          this.props.dialog.jvCompanyBranchId
        );
        if (isDuplicate) {
          this.showDuplicateDialog();
          return;
        }
      }
      // 協力会社一覧の新規登録で自社登録済みチェック
      if (selected.is_partners && this.fromPartnerCompanies()) {
        this.props.dialog.callback.showDuplicateDialog();
        return;
      }

      if (selected.buildee_use_flg && this.fromAgencyRegister()) {
        this.props.dialog.callback.submit(selected);
        return;
      }

      const listData = {
        selected,
        cacheParam,
        options,
        field_id: this.props.dialog.fieldId,
        prime_contractors_company_branch_id: this.props.dialog
          .jvCompanyBranchId,
        prime_company_name: this.state.prime_company_name,
        field_tree_id: this.props.dialog.fieldTreeId,
      };
      if (!this.state.selected.buildee_use_flg) {
        // Buildee未加入
        this.props.dialog.callback.createCompany(listData);
      } else {
        // Buildee加入済

        let workHourZone = {};
        let workHourZoneSetting = {};
        // 施工体制から遷移した場合は現場情報から作業時間帯設定を取得する
        if (this.fromFieldTreePage()) {
          workHourZoneSetting = await this.getWorkHourZoneSetting();
          workHourZone = {
            work_hour_zone_day_flag: workHourZoneSetting.work_hour_zone_day_flag
              ? 1
              : 0,
            work_hour_zone_night_flag: workHourZoneSetting.work_hour_zone_night_flag
              ? 1
              : 0,
            work_hour_zone_midnight_flag: workHourZoneSetting.work_hour_zone_midnight_flag
              ? 1
              : 0,
          };
        }

        this.setState({
          confirmValues: {
            ...this.state.confirmValues,
            prime_company_name: listData.prime_company_name,
            company_selected_counts: listData.selected.company_selected_counts,
            company: {
              ...this.state.confirmValues.company,
              building_name: listData.selected.building_name,
              city_name: listData.selected.city_name,
              fax: listData.selected.fax,
              kana: listData.selected.kana,
              name: listData.selected.name,
              personal_flag: isNullOrEmpty(listData.selected.company_number)
                ? ONE_MASTER_FLAG.personal.id
                : ONE_MASTER_FLAG.corporation.id,
              postal_code: listData.selected.postal_code,
              prefectures_code_id: listData.selected.prefectures_code_id,
              street_number: listData.selected.street_number,
              tel: listData.selected.tel,
              company_number: listData.selected.company_number,
              id: listData.selected.id,
              juridical_personality_code:
                listData.selected.juridical_personality_code,
              one_owner_flag: listData.selected.one_owner_flag,
            },
            branch: this.state.selectedBranch,
          },
          formValues: {
            ...this.state.formValues,
            field_id: this.props.dialog.fieldId,
            parent_tree_id: this.props.dialog.fieldTreeId,
            company_branch_id: listData.selected.company_branch_id,
            prime_contractors_company_branch_id: this.props.dialog
              .jvCompanyBranchId,
            private_partner_company_flag: 0,
            ...workHourZone,
          },
          showConfirmDialog: true,
          workHourZoneSetting,
          isPartners: selected.is_partners,
          addDuplicateCompany: false,
        });
      }
    }
  };

  /**
   * 「この協力会社を追加」ボタンを押下・「登録して現場に追加」を押下
   * */
  confirmCreatePartnerCompany = () => {
    if (!this.validate()) {
      return false;
    }
    const { formValues, confirmValues } = this.state;
    try {
      return this.props.dialog.callback.confirmCreate(
        formValues,
        confirmValues
      );
    } catch (error) {
      // エラー発生
      return false;
    }
  };

  // 類似一覧で「新規に登録」ボタンを押下した場合表示する
  createCompany = async (personal_flag = ONE_MASTER_FLAG.personal.id) => {
    let workHourZone = {};
    let workHourZoneSetting = {};
    // 施工体制から遷移した場合は現場情報から作業時間帯設定を取得する
    if (this.fromFieldTreePage()) {
      workHourZoneSetting = await this.getWorkHourZoneSetting();
      workHourZone = {
        work_hour_zone_day_flag: workHourZoneSetting.work_hour_zone_day_flag
          ? 1
          : 0,
        work_hour_zone_night_flag: workHourZoneSetting.work_hour_zone_night_flag
          ? 1
          : 0,
        work_hour_zone_midnight_flag: workHourZoneSetting.work_hour_zone_midnight_flag
          ? 1
          : 0,
      };
    }

    const { company } = this.props.dialog.state;
    const confirmValues = {
      ...this.state.confirmValues,
      company_selected_counts: company.company_selected_counts,
      company: {
        ...this.state.confirmValues.company,
        building_name: company.building_name,
        city_name: company.city_name,
        company_number: '',
        fax: company.fax,
        id: '',
        juridical_personality_code: '',
        kana: company.kana,
        name: company.name,
        personal_flag: isNullOrEmpty(company.company_number)
          ? ONE_MASTER_FLAG.personal.id
          : ONE_MASTER_FLAG.corporation.id,
        postal_code: company.postal_code,
        prefectures_code_id: company.prefectures_code_id,
        street_number: company.street_number,
        tel: company.tel,
        one_owner_flag: company.one_owner_flag,
      },
    };
    const formValues = {
      ...this.state.formValues,
      prefecture_name: PREFECTURE_LISTS[company.prefectures_code_id],
      field_id: this.props.dialog.fieldId,
      parent_tree_id: this.props.dialog.fieldTreeId,
      prime_contractors_company_branch_id: this.props.dialog.jvCompanyBranchId,
      company_selected_counts: 0, // 利用実績（新規登録の場合は0）
      company: {
        ...this.state.formValues.company,
        name: company.name,
        kana: company.kana,
        postal_code: company.postal_code,
        prefectures_code_id: company.prefectures_code_id,
        city_name: company.city_name,
        street_number: company.street_number,
        building_name: company.building_name,
        tel: company.tel,
        fax: company.fax,
        personal_flag, // 個人
        joining_flag: JOINING_FLAG.contractorInherent.id, // 元請固有
      },
      one_owner_flag: company.one_owner_flag,
      ...workHourZone,
    };
    this.setState({
      confirmValues,
      formValues,
      showConfirmDialog: true,
      createCompanyFlag: true, // 新規登録
      workHourZoneSetting,
    });
  };

  /**
   * この協力会社を追加ボタンを押下
   * */
  confirmAdd = () => {
    this.setState({
      showConfirmDialog: true,
    });
  };

  validate = () => {
    if (this.fromFieldTreePage()) {
      return this.validateWorkHourValues();
    }

    // 作業時間帯以外にvalidate対象がないため
    return true;
  };

  validateWorkHourValues = () => {
    const { formValues } = _.cloneDeep(this.state);
    const workHourValues = [
      formValues.work_hour_zone_day_flag,
      formValues.work_hour_zone_night_flag,
      formValues.work_hour_zone_midnight_flag,
    ];
    const result = _.some(workHourValues, value => {
      return value === FIELD_WORK_HOUR_ZONES.on.id;
    });
    // 作業時間帯
    if (result) {
      this.setState({
        validate: '',
      });
    } else {
      this.setState({
        validate: '必須です',
      });
    }
    return result;
  };

  /**
   * 現場に追加ボタンを押下
   * */
  submit = async () => {
    if (!this.validate()) {
      return false;
    }
    const {
      formValues,
      confirmValues,
      similarCompanyExists,
      isPartners,
    } = this.state;
    formValues.partner_company_branch_id = _.get(
      confirmValues,
      'branch.id',
      null
    );

    // 協力会社一覧 => 類似協力会社ダイアログ => リストから選択 => 協力会社に追加
    if (similarCompanyExists && this.fromPartnerCompanies()) {
      this.props.dialog.callback.submit(confirmValues.company);
    } else {
      this.props.dialog.callback.submit(formValues, confirmValues, isPartners);
    }
    return true;
  };

  checkDuplicate = async (
    field_id,
    company_branch_id,
    prime_contractors_company_branch_id
  ) => {
    const response = await FieldTreeService.checkDuplicate(field_id, {
      field_id,
      company_branch_id,
      prime_contractors_company_branch_id,
    });
    if (
      response &&
      response.result &&
      _.has(response, 'data.entities.is_duplicate')
    ) {
      return Boolean(response.data.entities.is_duplicate);
    }
  };

  showDuplicateDialog = () => {
    this.setState({ showDuplicateDialog: true });
  };

  hideDuplicateDialog = () => {
    this.setState({ showDuplicateDialog: false });
  };

  addDuplicateCompany = () => {
    this.setState(
      { showDuplicateDialog: false, addDuplicateCompany: true },
      () => {
        this.selectCompany();
      }
    );
  };

  showCheckPartnerCompanyDialog = () => {
    this.setState({ showCheckPartnerCompanyDialog: true });
  };

  selectCompanyAgain = () => {
    this.setState({
      showCheckPartnerCompanyDialog: false,
    });
    this.isSelectingCompany = false;
    this.selectCompany();
  };

  backPartnerCompanyDialog = () => {
    this.setState({
      showCheckPartnerCompanyDialog: false,
      selected: this.state.cacheSlected,
    });
    this.isSelectingCompany = false;
  };

  handleClickSelectCompany = async () => {
    this.selectCompany();
  };

  // 協力会社一覧から遷移した場合と施工体系図から遷移した場合と分けるための判定
  fromFieldTreePage = () => {
    return loadFromFieldTreePage(this.props.dialog.loadFrom);
  };

  // 協力会社一覧から遷移した場合と施工体系図から遷移した場合と分けるための判定
  fromPartnerCompanies = () => {
    return loadFromPartnerCompanies(this.props.dialog.loadFrom);
  };

  fromAgencyRegister = () => {
    return loadFromAgencyRegister(this.props.dialog.loadFrom);
  };

  // 新規協力会社登録の権限チェック
  canCreateCompany = () => {
    if (this.state.similarCompanyExists) {
      return false;
    }
    if (this.fromFieldTreePage()) {
      return this.canProxyRegister();
    }
    if (this.fromPartnerCompanies()) {
      return true;
    }

    if (this.fromAgencyRegister()) {
      return true;
    }
    return false;
  };

  // 2次以下の協力会社管理者か権限チェック
  // 2次以下の場合はfalse
  canProxyRegister = () => {
    if (
      _.has(this.props, 'dialog.state.permissions.partner_box.proxy_register')
    ) {
      return this.props.dialog.state.permissions.partner_box.proxy_register;
    } else {
      throw new Error('権限の取得に失敗しました。');
    }
  };

  setTableHeight = () => {
    if (this.tableDescriptionRef && this.tableDescriptionRef.current) {
      const tableDescriptionHeight = _.round(
        this.tableDescriptionRef.current.getBoundingClientRect().height
      );

      this.setState({
        tableHeight: `calc(100% - ${tableDescriptionHeight}px)`,
      });
    }
  };

  async componentDidMount() {
    this.setTableHeight();
    if (this.fromFieldTreePage() || this.state.similarCompanyExists) {
      await this.checkForPreviousSearch();
      this.fetchPartnerCompany();
    }
    if (this.fromAgencyRegister()) {
      if (_.has(this.props.dialog.state.options, 'cacheParam')) {
        await this.checkForPreviousSearch();
        this.fetchPartnerCompany();
      } else {
        this.setState({
          searchIsOpen: true,
        });
      }
    }

    if (this.fromPartnerCompanies()) {
      // cacheParamがある場合のみ検索データを取得する
      const fromPreviousSearch = await this.checkForPreviousSearch();
      if (fromPreviousSearch) {
        this.fetchPartnerCompany();
      } else {
        this.setState({
          searchIsOpen: true,
        });
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.searchWithCorporate !== this.state.searchWithCorporate ||
      prevState.searchIsOpen !== this.state.searchIsOpen ||
      prevState.messages !== this.state.messages
    ) {
      this.setTableHeight();
    }
  }

  hideUsageStatus = () => {
    const isJVFieldTree = !_.isNil(this.props.dialog.jvFieldTree)
      ? this.props.dialog.jvFieldTree
      : false;

    return isJVFieldTree && isPrimaryCompanyRoleId(this.roleId);
  };

  renderTableHeader = () => {
    const renderCommonHeader = () => {
      if (this.fromFieldTreePage()) {
        return (
          <React.Fragment>
            <th className='data-table__head' />
            <th className='data-table__head'>社名・屋号・氏名</th>
            <th className='data-table__head'>住所</th>
            <th className='data-table__head'>電話番号</th>
            <th className='data-table__head'>法人番号</th>
          </React.Fragment>
        );
      }

      return (
        <React.Fragment>
          <th className='data-table__head' />
          <th className='data-table__head'>法人番号</th>
          <th className='data-table__head'>社名・屋号・氏名</th>
          <th className='data-table__head'>住所</th>
          <th className='data-table__head'>電話番号</th>
        </React.Fragment>
      );
    };

    // JVの施工体系図の協力会社一覧では利用実績を非表示
    if (this.fromPartnerCompanies() || this.hideUsageStatus()) {
      return (
        <tr>
          {renderCommonHeader()}
          <th className='data-table__head'>管理者数</th>
          <th className='data-table__head'>職長数</th>
          <th className='data-table__head'>作業員数</th>
        </tr>
      );
    }

    if (this.fromAgencyRegister()) {
      return (
        <tr>
          {renderCommonHeader()}
          <th className='data-table__head'>代行関係</th>
        </tr>
      );
    }

    return (
      <tr>
        {renderCommonHeader()}
        <th className='data-table__head'>管理者数</th>
        <th className='data-table__head'>職長数</th>
        <th className='data-table__head'>作業員数</th>
        <th className='data-table__head'>利用実績</th>
      </tr>
    );
  };

  renderTableBody = () => {
    const { data, similarCompanyExists, selected, selectedKey } = this.state;

    return (
      !_.isEmpty(data) &&
      _.map(data, (company, i) => {
        // 項目が個人事業主、そして協力会社一覧に利用実績がない場合はマスキングで表示する
        const loadFrom = this.props.dialog.loadFrom;
        const maskResult =
          !similarCompanyExists &&
          !company.company_number &&
          !company.is_partners;
        const cityName = _.get(company, 'city_name', '');
        const streetNumber = _.get(company, 'street_number', '');
        const buildingName = _.get(company, 'building_name', '');
        const address = maskResult
          ? (company.prefecture_name || '') + (cityName || '')
          : (company.prefecture_name || '') +
            (cityName || '') +
            (streetNumber || '') +
            (buildingName || '');
        const tel = maskResult ? maskTel(company.tel) : company.tel;
        const branches = _.get(company, 'partner_company_branches');
        const isCompanyChecked = selected && selectedKey === i;
        const isBranchChecked = branch =>
          selected && selectedKey === `branch-${branch.id}`;
        const handleSelect = (company, branch) => {
          const selectedKey = branch ? `branch-${branch.id}` : i;
          this.setState({
            noSelectedCompany: false,
            selected: company,
            selectedBranch: branch,
            selectedKey,
          });
        };

        return (
          <React.Fragment key={`PartnerCompanyAdd-${i}`}>
            <PartnerSelectTableRow
              prime_company_name={this.state.prime_company_name}
              company_number={company.company_number}
              fromFieldTreePage={this.fromFieldTreePage()}
              is_principal={company.is_principal}
              name={company.name}
              kana={company.kana}
              address={address}
              tel={tel}
              manager_count={company.partner_count}
              foreman_count={company.foreman_count}
              worker_count={company.worker_count}
              usage_count={company.company_selected_counts}
              latest_application_id={company.latest_application_id}
              latest_application_status={company.latest_application_status}
              checked={isCompanyChecked}
              load_from={loadFrom}
              usageMarkDisabled={this.hideUsageStatus()}
              onClick={() => handleSelect(company)}
            />
            {!_.isEmpty(branches) &&
              loadFromFieldTreePage(loadFrom) &&
              _.map(branches, branch => {
                return (
                  <PartnerCompanyBranchSelectTableRow
                    key={`branch-${branch.id}`}
                    branch={branch}
                    checked={isBranchChecked(branch)}
                    onClick={() => handleSelect(company, branch)}
                    usageMarkDisabled={this.hideUsageStatus()}
                  />
                );
              })}
          </React.Fragment>
        );
      })
    );
  };

  handlePartnerCompanyBranchDropdownChange = id => {
    const { confirmValues } = this.state;

    this.setState({
      confirmValues: {
        ...confirmValues,
        branch: { id },
      },
    });
  };

  resetIsSelectingCompany = () => {
    this.isSelectingCompany = false;
    this.isCreatingCompany = false;
  };

  renderSearchDescriptionMessage = () => {
    let descriptionMessage =
      '現場体制に追加したい協力会社を検索し、一覧から選択してください。Buildeeを利用したことのない個人事業主を追加したい場合は、新規登録を行ってください。';
    if (this.fromAgencyRegister()) {
      descriptionMessage =
        '代行登録を行いたい会社を検索し、一覧から選択してください。Buildeeを利用したことのない個人事業主の代行登録をしたい場合は、新規登録を行ってください。';
    } else if (this.fromPartnerCompanies()) {
      descriptionMessage =
        '協力会社一覧に追加したい協力会社を検索し、一覧から選択してください。Buildeeを利用したことのない個人事業主を追加したい場合は、新規登録を行ってください。';
    } else if (this.fromFieldTreePage() && !this.canProxyRegister()) {
      // 2次以下の協力会社
      descriptionMessage =
        '現場体制に追加したい協力会社を検索し、一覧から選択してください。なお、Buildeeに登録されていない会社は追加できません。新規登録は元請会社もしくは一次協力会社に依頼してください。';
    }

    return (
      <Description>
        <p className='dialog__text'>{descriptionMessage}</p>
      </Description>
    );
  };

  redirectToCreateCompanyPage = () => {
    if (this.canCreateCompany()) {
      return this.props.dialog.callback.create();
    }
    this.setState({ showWarningCreateCompany: true });
  };

  render() {
    const dialogTitle = () => {
      if (this.fromPartnerCompanies()) {
        return '協力会社一覧に追加する協力会社を探す';
      }
      if (this.fromFieldTreePage()) {
        return '現場体制に追加する協力会社を探す';
      }
      if (this.fromAgencyRegister()) {
        return '代行登録する会社を探す';
      }
      return '';
    };

    const closeBtnText = () => {
      if (
        _.has(this.props, 'dialog.state.similarCompanyExists') &&
        this.props.dialog.state.similarCompanyExists
      ) {
        return '登録をやめる';
      }
      return '閉じる';
    };
    const selectCompanyBtnText = () => {
      if (
        _.has(this.props, 'dialog.state.similarCompanyExists') &&
        this.props.dialog.state.similarCompanyExists
      ) {
        return 'リストから追加';
      }
      if (this.fromAgencyRegister()) {
        return 'この会社を選択';
      }
      return '選択した会社を追加';
    };

    // 施工体系図画面で協力会社管理者ユーザーの場合「代行先の会社のみを表示」検索オプションを表示する
    const showAgencyToggleCheckbox = () => {
      if (this.fromFieldTreePage() && isPartnerRoleId(this.roleId)) {
        return true;
      }
      return false;
    };

    const isShowAgencyToggleCheckbox = showAgencyToggleCheckbox();

    return (
      <div
        className='dialog dialog--full dialog--modal FieldAddPartnerCompany'
        style={
          this.state.showConfirmDialog ||
          this.state.showCheckPartnerCompanyDialog
            ? { zIndex: '-1' }
            : {}
        }
      >
        <div className='dialog__header'>
          <span className='dialog__title'>
            {this.state.similarCompanyExists
              ? '類似している会社を確認'
              : dialogTitle()}
          </span>
        </div>
        <div className='dialog__body'>
          <div ref={this.tableDescriptionRef}>
            {this.state.similarCompanyExists ? (
              <React.Fragment>
                <div className='dialog__text-box'>
                  <p className='dialog__text'>
                    入力した内容と類似した協力会社が既にBuildeeに登録されています。{' '}
                    <br />
                    二重登録を防止するため、以下のリストの中に登録しようとしている協力会社がないか確認してください。{' '}
                    <br />
                    リストの中に登録しようとしている協力会社があればその会社を選択してください。
                  </p>
                </div>
                <p className='dialog__text dialog__text--title'>
                  登録しようとしている個人事業主情報
                </p>
                <div className='dialog-table dialog-table--disabled'>
                  <table className='data-table'>
                    <thead className='data-table__header'>
                      <tr>
                        <th className='data-table__head'>氏名または屋号</th>
                        <th className='data-table__head'>
                          氏名または屋号（ふりがな）
                        </th>
                        <th className='data-table__head'>住所</th>
                        <th className='data-table__head'>電話番号</th>
                        <th className='data-table__head'>FAX番号</th>
                        <th className='data-table__head' />
                      </tr>
                    </thead>
                    <tbody className='data-table__table-body data-table__register-company'>
                      <tr className='dialog-table__item'>
                        <td className='data-table__cell data-table__cell--min-10 data-table__cell--xl'>
                          <Tippy
                            duration={10}
                            distance={24}
                            arrowType='sharp'
                            delay={[500, 0]}
                            placement='bottom'
                            followCursor={true}
                            html={
                              <ToolTip>
                                {this.props.dialog.state.company.name}
                              </ToolTip>
                            }
                          >
                            <div className='data-table__content'>
                              {this.props.dialog.state.company.name}
                            </div>
                          </Tippy>
                        </td>
                        <td className='data-table__cell data-table__cell--min-10 data-table__cell--xl'>
                          <Tippy
                            duration={10}
                            distance={24}
                            arrowType='sharp'
                            delay={[500, 0]}
                            placement='bottom'
                            followCursor={true}
                            html={
                              <ToolTip>
                                {this.props.dialog.state.company.kana}
                              </ToolTip>
                            }
                          >
                            <div className='data-table__content'>
                              {this.props.dialog.state.company.kana
                                ? this.props.dialog.state.company.kana
                                : ''}
                            </div>
                          </Tippy>
                        </td>
                        <td className='data-table__cell data-table__cell--min-10 data-table__cell--xl'>
                          <Tippy
                            duration={10}
                            distance={24}
                            arrowType='sharp'
                            delay={[500, 0]}
                            placement='bottom'
                            followCursor={true}
                            html={
                              <ToolTip>
                                {this.props.dialog.state.company.address}
                              </ToolTip>
                            }
                          >
                            <div className='data-table__content'>
                              {this.props.dialog.state.company.address}
                            </div>
                          </Tippy>
                        </td>
                        <td className='data-table__cell data-table__cell--fix-md data-table__cell--minimum'>
                          {this.props.dialog.state.company.tel}
                        </td>
                        <td className='data-table__cell data-table__cell--fix-md data-table__cell--minimum'>
                          {this.props.dialog.state.company.fax
                            ? this.props.dialog.state.company.fax
                            : ''}
                        </td>
                        <td className='data-table__cell data-table__cell--fix-md data-table__cell--minimum data-table__cell--button-cell'>
                          <button
                            className='btn--sub'
                            onClick={() => {
                              this.props.dialog.callback.back();
                            }}
                          >
                            個人事業主情報を修正
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <div className='dialog__text-box'>
                  {this.renderSearchDescriptionMessage()}
                </div>
                <SearchForm
                  handleInput={this.handleInput}
                  switchSearchMethod={this.switchSearchMethod}
                  handleBlur={this.handleBlur}
                  param={this.state.param}
                  onOpen={this.searchFormOnOpen}
                  onSearchExecution={this.onSearchExecution}
                  searchButtonRef={this.searchButtonRef}
                  isOpen={this.state.searchIsOpen}
                  total={this.state.total}
                  searchParams={this.state.searchParams}
                  searchWithCorporate={this.state.searchWithCorporate}
                  clearConditions={this.clearConditions}
                  messages={this.state.messages}
                  searchParamValidate={this.searchParamValidate}
                  isShowAgencyToggleCheckbox={isShowAgencyToggleCheckbox}
                  toggleSearchOnlyAgency={this.toggleSearchOnlyAgency}
                  validationMessage={this.state.validationMessage}
                />
              </React.Fragment>
            )}
            <div className='dialog-table__legend'>
              <div className='dialog-table__legend-left'>
                {this.state.similarCompanyExists && (
                  <p className='dialog__text dialog__text--title'>
                    入力内容と類似した会社
                  </p>
                )}
              </div>
              {this.fromFieldTreePage() && !this.hideUsageStatus() && (
                <div className='dialog-table__legend-right'>
                  <ul className='dialog-table__legend-list'>
                    <li className='dialog-table__legend-item'>
                      <span className='dialog-table__legend-mark dialog-table__legend-mark--many'>
                        ★
                      </span>
                      よく利用する
                    </li>
                    <li className='dialog-table__legend-item'>
                      <span className='dialog-table__legend-mark dialog-table__legend-mark--some'>
                        ●
                      </span>
                      時々利用する
                    </li>
                    <li className='dialog-table__legend-item'>
                      <span className='dialog-table__legend-mark dialog-table__legend-mark--any'>
                        ▲
                      </span>
                      利用したことがある
                    </li>
                    <li className='dialog-table__legend-item'>
                      <span className='dialog-table__legend-mark dialog-table__legend-mark--none'>
                        ×
                      </span>
                      利用したことがない
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </div>
          <div
            style={{
              height: this.state.tableHeight,
            }}
            className={`dialog-table`}
          >
            <div
              id='infinityscroll-target-popup'
              className='dialog-table__scroll-list'
            >
              <table className='data-table dialog-table__table'>
                <thead className='data-table__header'>
                  {this.renderTableHeader()}
                </thead>
                <tbody
                  className={
                    this.state.noSelectedCompany
                      ? 'data-table__group dialog-table__table-body dialog-table__table-body--error'
                      : 'data-table__group dialog-table__table-body'
                  }
                >
                  {this.renderTableBody()}
                </tbody>
              </table>
              <InfinityScrollLoad
                targetId={`infinityscroll-target-popup`}
                total={_.size(this.state.data)}
                callback={notifyEnd => {
                  this.fetchPartnerCompany(notifyEnd);
                }}
                isLoading={this.state.isLoading}
                no_data_message={this.state.noDataMessage}
                reset={true}
                largeMessageFlag={true}
              />
            </div>
          </div>
        </div>
        <div className='dialog__footer dialog__footer--horizontal'>
          {this.state.noSelectedCompany && (
            <div className='dialog-table__error'>
              <p className='dialog-table__error-message'>
                登録したい会社を選択してください。
              </p>
            </div>
          )}
          <button
            className='btn-fixedsize--sub'
            onClick={() => {
              this.props.dialog.callback.close();
            }}
          >
            {closeBtnText()}
          </button>
          {this.state.similarCompanyExists && (
            <button
              className='btn-fixedsize'
              onClick={() => {
                if (this.isCreatingCompany) {
                  return;
                }
                this.isCreatingCompany = true;

                this.createCompany();
              }}
            >
              新規に登録
            </button>
          )}
          <button
            className='btn-fixedsize'
            onClick={this.handleClickSelectCompany}
          >
            {selectCompanyBtnText()}
          </button>
          {!this.state.similarCompanyExists && (
            <button
              className={`btn-fixedsize--dialog-footer-right
            ${
              this.canCreateCompany() ? ' btn-fixedsize' : ' btn-fixedsize--sub'
            }`}
              onClick={this.redirectToCreateCompanyPage}
            >
              一覧にない個人事業主を新規登録
            </button>
          )}
        </div>
        <Confirmation
          visible={this.state.showDuplicateDialog}
          title={messageUtility.getMessage('I-000-121')}
          confirmButtonText={messageUtility.getMessage('I-000-122')}
          cancelButtonText={messageUtility.getMessage('I-000-123')}
          message={messageUtility.getMessage('W-000-004')}
          onConfirm={() => {
            this.addDuplicateCompany();
            this.isSelectingCompany = false;
          }}
          onCancel={() => {
            this.hideDuplicateDialog();
            this.isSelectingCompany = false;
          }}
        />
        <Information
          visible={this.state.showWarningCreateCompany}
          title={messageUtility.getMessage('I-000-184')}
          message={messageUtility.getMessage('I-000-185')}
          buttonText={messageUtility.getMessage('I-000-017')}
          onClose={() => this.setState({ showWarningCreateCompany: false })}
          multilineText={true}
        />
        {this.state.showConfirmDialog && (
          <PartnerCompanyRegisterConfirmDialog
            createCompanyFlag={this.state.createCompanyFlag}
            events={this.events.form}
            prime_company_name={this.state.prime_company_name}
            validate={this.state.validate}
            values={this.state.confirmValues}
            visible={this.state.showConfirmDialog === true}
            formValues={this.state.formValues}
            loadFrom={this.props.dialog.loadFrom}
            workHourZoneSetting={this.state.workHourZoneSetting}
            isPartners={this.state.isPartners}
            canProxyRegister={this.canProxyRegister}
            onSelect={this.handlePartnerCompanyBranchDropdownChange}
            companyId={this.companyId}
            resetIsSelectingCompany={this.resetIsSelectingCompany}
          />
        )}
        {this.state.showCheckPartnerCompanyDialog && (
          <ShowCheckPartnerCompanyDialog
            visible={this.state.showCheckPartnerCompanyDialog}
            companyName={this.state.selected.name}
            companyAddress={
              (this.state.selected.prefecture_name || '') +
              (this.state.selected.city_name || '') +
              (this.state.selected.street_number || '') +
              (this.state.selected.building_name || '')
            }
            company_number={this.state.selected.company_number}
            onBack={this.backPartnerCompanyDialog}
            onNew={this.selectCompanyAgain}
            fromFieldTreePage={this.fromFieldTreePage()}
            fromPartnerCompanies={this.fromPartnerCompanies()}
            fromAgencyRegister={this.fromAgencyRegister()}
          />
        )}
      </div>
    );
  }
}

/**
 * @description 検索フォーム
 * @param {function} onOpen 検索フォーム開閉処理
 * @param {boolean} isOpen true: オープン, false: クローズ
 * @param {number} total 取得現場件数
 * @param {function} clearParams 検索条件クリア処理
 */
const SearchForm = ({
  handleInput,
  switchSearchMethod,
  handleBlur,
  param,
  onOpen,
  onSearchExecution,
  searchButtonRef,
  searchWithCorporate,
  isOpen,
  total,
  clearConditions,
  messages,
  searchParamValidate,
  isShowAgencyToggleCheckbox,
  toggleSearchOnlyAgency,
  validationMessage,
}) => {
  const searchButtonClassName = () => {
    let className = 'btn-fixedsize btn-fixedsize--contained search-btn';
    return className;
  };

  const handleClick = () => {
    onSearchExecution();
  };

  const searchRecommendation = `※本社・本店の住所をご指定いただくことで検索速度が向上します。`;

  return (
    <div className='master-slide-view__searchform'>
      <div className='search-form'>
        <SearchFormHeader
          onOpen={onOpen}
          isOpen={isOpen}
          total={total}
          clearConditions={clearConditions}
        />
        <div
          id='search-form-accordion'
          className={isOpen ? 'accordion show' : 'accordion'}
        >
          <div className='search-form__body search-form__body--dialog'>
            <div className='form-list__element--tab'>
              <div className='form-list__element-main'>
                <div className='form-list-radio form-list-default'>
                  <div className='form-list-radio__item'>
                    <label
                      htmlFor={`search-form-without-corporate`}
                      className='radio'
                    >
                      <input
                        type='radio'
                        id={`search-form-without-corporate`}
                        value={0}
                        checked={searchWithCorporate === false}
                        onChange={switchSearchMethod}
                      />
                      <RadioButtonIcon className='icon--1_4x' />
                      <span>会社情報で検索する</span>
                    </label>
                  </div>
                  <div className='form-list-radio__item'>
                    <label
                      htmlFor={`search-form-with-corporate`}
                      className='radio'
                    >
                      <input
                        type='radio'
                        id={`search-form-with-corporate`}
                        value={1}
                        checked={searchWithCorporate === true}
                        onChange={switchSearchMethod}
                      />
                      <RadioButtonIcon className='icon--1_4x' />
                      <span>法人番号で検索する</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            {searchWithCorporate ? (
              <React.Fragment>
                <div className='form-list__element--dialog'>
                  <div className='form-list__element-main'>
                    <div className='search-form__layout'>
                      <div className='search-form__item'>
                        <div className='search-form__item'>
                          <span className='label search-form__label'>
                            法人番号
                          </span>
                          <FormInput
                            type='text'
                            name='company_number'
                            value={param.company_number}
                            onChange={event =>
                              handleInput('company_number', event.target.value)
                            }
                            onBlur={() => {
                              handleBlur('company_number');
                            }}
                            width={180}
                          />
                        </div>
                        <div>
                          <div className='search-form__layout--sub'>
                            <button
                              className={searchButtonClassName()}
                              onClick={handleClick}
                              ref={searchButtonRef}
                            >
                              検索
                            </button>
                          </div>
                          {validationMessage && (
                            <div
                              className='search-form__layout--sub form-list__alert show'
                              style={{ position: 'absolute' }}
                            >
                              {validationMessage}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  {(messages.company_number || validationMessage) && (
                    <div className={'form-list__alert show'}>
                      {messages.company_number || ''}
                    </div>
                  )}
                </div>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <div className='form-list__element--dialog'>
                  <div className='form-list__element-main'>
                    <div className='search-form__layout'>
                      <div className='search-form__item search-form__item--name'>
                        <span className='label search-form__label'>
                          会社名・屋号・氏名（かな検索可）
                        </span>
                        <FormInput
                          type='text'
                          name='name_kana'
                          value={param.name_kana}
                          onChange={event =>
                            handleInput('name_kana', event.target.value)
                          }
                          onBlur={() => {
                            handleBlur('name_kana');
                          }}
                          width={210}
                        />
                      </div>
                    </div>
                    <div className='search-form__layout'>
                      <div className='search-form__item'>
                        <span className='label search-form__label'>
                          電話番号
                        </span>
                        <Tel
                          value={param.tel}
                          handleOnChange={handleInput}
                          setKey='tel'
                          validate={() => {
                            handleBlur('tel');
                          }}
                          isSearch={true}
                        />
                      </div>
                      {messages.tel && (
                        <div className='form-list__alert show'>
                          {messages.tel}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className='form-list__element--dialog'>
                  <div className='form-list__element-main'>
                    <div className='search-form__layout'>
                      <div className='search-form__item'>
                        <div className='search-form__item'>
                          <span className='label search-form__label'>
                            会社種別
                          </span>
                          <FormSelect
                            name='one_master_flag'
                            value={param.one_master_flag}
                            onChange={event =>
                              handleInput('one_master_flag', event.target.value)
                            }
                            onBlur={() => handleBlur('one_master_flag')}
                            width={115}
                          >
                            <option value=''>すべて</option>
                            <option value={ONE_MASTER_FLAG.personal.id}>
                              個人事業主
                            </option>
                            <option value={ONE_MASTER_FLAG.corporation.id}>
                              法人
                            </option>
                          </FormSelect>
                        </div>
                        <div className='search-form__layout--sub'>
                          <div className='search-form__item'>
                            <span className='label search-form__label'>
                              住所
                            </span>
                            <FormSelect
                              name='prefectures_code_id'
                              value={param.prefectures_code_id}
                              onChange={event => {
                                handleInput(
                                  'prefectures_code_id',
                                  event.target.value
                                );
                              }}
                              onBlur={() => {
                                handleBlur('prefectures_code_id');
                              }}
                              width={100}
                            >
                              <option value=''>都道府県</option>
                              {_.map(PREFECTURE_GROUPS, (region, index) => (
                                <optgroup key={index} label={region.label}>
                                  {_.map(region.prefectures, prefecture => (
                                    <option
                                      key={prefecture.id}
                                      value={prefecture.id}
                                    >
                                      {prefecture.name}
                                    </option>
                                  ))}
                                </optgroup>
                              ))}
                            </FormSelect>
                          </div>
                        </div>
                        <div className='search-form__layout--sub'>
                          <div className='search-form__item'>
                            <span className='label search-form__label'>
                              市区町村
                            </span>
                            <FormInput
                              type='text'
                              name='city_name'
                              value={param.city_name}
                              onChange={event =>
                                handleInput('city_name', event.target.value)
                              }
                              onBlur={() => {
                                handleBlur('city_name');
                              }}
                              width={210}
                            />
                          </div>
                        </div>
                        {isShowAgencyToggleCheckbox && (
                          <div className='search-form__layout--sub'>
                            <div className='search-form__item'>
                              <div className='btn-checkbox'>
                                <label htmlFor={`toggle_agency`}>
                                  <input
                                    id={`toggle_agency`}
                                    type='checkbox'
                                    checked={param.is_agent_to === API_FLAG.On}
                                    onChange={toggleSearchOnlyAgency}
                                  />
                                  <i className='i-square-checkbox i-2_5x' />
                                </label>
                              </div>
                              <span
                                className='label search-form__label search-form__label--checkbox'
                                onClick={toggleSearchOnlyAgency}
                              >
                                代行先の会社のみを表示
                              </span>
                            </div>
                          </div>
                        )}
                      </div>
                      {messages.address && (
                        <div className='form-list__alert show'>
                          {messages.address || ''}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className='form-list__element--dialog'>
                  <div className='search-form__item'>
                    <div className='search-form__item'>
                      <button
                        className={searchButtonClassName()}
                        onClick={handleClick}
                        ref={searchButtonRef}
                      >
                        検索
                      </button>
                    </div>

                    <div className='search-recommendation'>
                      {searchRecommendation}
                    </div>
                  </div>

                  {validationMessage && (
                    <div className='form-list__alert show'>
                      {validationMessage}
                    </div>
                  )}
                </div>
              </React.Fragment>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

/**
 * @description 検索フォームヘッダー
 * @param {function} onOpen 検索フォーム開閉処理
 * @param {boolean} isOpen true: オープン, false: クローズ
 * @param {number} total 取得現場件数
 * @param {function} clearParams 検索条件クリア処理
 */
const SearchFormHeader = ({ onOpen, isOpen, total, clearConditions }) => (
  <div className='search-form__header'>
    <div className='search-form__title search-form__title--dialog'>
      検索条件（検索結果
      <span className='bold'>{total}</span>
      件)
    </div>
    <button
      id='accordion-toggle'
      className={isOpen ? 'accordion__btn show' : 'accordion__btn'}
      onClick={onOpen}
    />
    <button className='btn-text--sm' onClick={clearConditions}>
      検索条件クリア
    </button>
  </div>
);

/**
 * @description 協力会社一覧項目
 */
const PartnerSelectTableRow = ({
  address,
  checked,
  company_number,
  foreman_count,
  manager_count,
  latest_application_id,
  latest_application_status,
  name,
  onClick,
  tel,
  usage_count,
  worker_count,
  load_from,
  usageMarkDisabled,
  is_principal,
  fromFieldTreePage,
}) => {
  const displayCompanyNumber = isNullOrEmpty(company_number)
    ? ONE_MASTER_FLAG.personal.name
    : company_number;

  const usageMark =
    usage_count >= 10
      ? { text: '★', className: 'dialog-table__legend-mark--many' }
      : usage_count >= 2
      ? { text: '●', className: 'dialog-table__legend-mark--some' }
      : usage_count >= 1
      ? { text: '▲', className: 'dialog-table__legend-mark--any' }
      : { text: '×', className: 'dialog-table__legend-mark--none' };

  const parseAgencyStatus = status => {
    switch (status) {
      case AGENCY_REGISTRATION_APPLICATION_STATUS.APPLIED.ID:
      case AGENCY_REGISTRATION_APPLICATION_STATUS.APPROVED.ID:
        return '申請済';
      case AGENCY_REGISTRATION_APPLICATION_STATUS.NOT_APPLIED.ID:
        return '申請保留';
      default:
        return '';
    }
  };

  return (
    <tr className='dialog-table__item' onClick={onClick}>
      <td className='value-table value-table--icon data-table__cell--fix-minimum radio'>
        <RadioButtonIcon
          className={checked ? 'icon--1_6x checked' : 'icon--1_6x'}
        />
      </td>
      {!loadFromFieldTreePage(load_from) && (
        <td className='data-table__cell data-table__cell--fix-md'>
          <div className='data-table__content'>{displayCompanyNumber}</div>
        </td>
      )}
      <td className='data-table__cell data-table__cell--min-15 data-table__cell--xl'>
        <Tippy
          duration={10}
          distance={24}
          arrowType='sharp'
          delay={[500, 0]}
          placement='bottom'
          followCursor={true}
          html={<ToolTip>{name}</ToolTip>}
        >
          <div className='data-table__content data-table__content--one-line data-table__content--one-line-with-tooltip bold'>
            {fromFieldTreePage && is_principal && (
              <React.Fragment>
                <img style={{ verticalAlign: 'middle' }} src={PrincipalIcon} />
                {' '}
              </React.Fragment>
            )}{name}
          </div>
        </Tippy>
      </td>
      <td className='data-table__cell data-table__cell--min-20 data-table__cell--xl'>
        <Tippy
          duration={10}
          distance={24}
          arrowType='sharp'
          delay={[500, 0]}
          placement='bottom'
          followCursor={true}
          html={<ToolTip>{address}</ToolTip>}
        >
          <div className='data-table__content data-table__content--one-line data-table__content--one-line-with-tooltip'>
            {address}
          </div>
        </Tippy>
      </td>
      <td className='data-table__cell data-table__cell--fix-md data-table__cell--minimum '>
        <div className='data-table__content'>{tel}</div>
      </td>
      {loadFromFieldTreePage(load_from) && (
        <td className='data-table__cell data-table__cell--fix-md'>
          <div className='data-table__content'>{displayCompanyNumber}</div>
        </td>
      )}
      {!loadFromAgencyRegister(load_from) && (
        <React.Fragment>
          <td className='data-table__cell data-table__cell--fix-minimum data-table__cell--minimum'>
            <div className='data-table__content'>{manager_count}人</div>
          </td>
          <td className='data-table__cell data-table__cell--fix-minimum data-table__cell--minimum'>
            <div className='data-table__content'>{foreman_count}人</div>
          </td>
          <td className='data-table__cell data-table__cell--fix-minimum data-table__cell--minimum'>
            <div className='data-table__content'>{worker_count}人</div>
          </td>
        </React.Fragment>
      )}
      {loadFromFieldTreePage(load_from) && !usageMarkDisabled && (
        <td className='data-table__cell data-table__cell--fix-minimum data-table__cell--minimum'>
          <span className={`dialog-table__legend-mark ${usageMark.className}`}>
            {usageMark.text}
          </span>
        </td>
      )}
      {loadFromAgencyRegister(load_from) && (
        <td className='data-table__cell data-table__cell--fix-minimum data-table__cell--minimum'>
          <div className='data-table__content'>
            {parseAgencyStatus(latest_application_status)}
          </div>
        </td>
      )}
    </tr>
  );
};

const PartnerCompanyBranchSelectTableRow = ({
  branch,
  checked,
  onClick,
  usageMarkDisabled,
}) => {
  const { name, address, tel } = branch;

  return (
    <tr
      className='dialog-table__item FieldAddPartnerCompany__branch'
      onClick={onClick}
    >
      <td className='value-table value-table--icon data-table__cell--fix-minimum radio'>
        <RadioButtonIcon
          className={checked ? 'icon--1_6x checked' : 'icon--1_6x'}
        />
      </td>
      <td className='data-table__cell data-table__cell--min-15 data-table__cell--xl'>
        <div className='bullet-point'>
          <div className='bullet-point__icon' />
          <Tippy
            duration={10}
            distance={24}
            arrowType='sharp'
            delay={[500, 0]}
            placement='bottom'
            followCursor={true}
            html={<ToolTip>{name}</ToolTip>}
          >
            <div className='data-table__content data-table__content-branch-name data-table__content--one-line data-table__content--one-line-with-tooltip'>
              {name}
            </div>
          </Tippy>
        </div>
      </td>
      <td className='data-table__cell data-table__cell--min-20 data-table__cell--xl'>
        <Tippy
          duration={10}
          distance={24}
          arrowType='sharp'
          delay={[500, 0]}
          placement='bottom'
          followCursor={true}
          html={<ToolTip>{address}</ToolTip>}
        >
          <div className='data-table__content data-table__content--one-line data-table__content--one-line-with-tooltip'>
            {address}
          </div>
        </Tippy>
      </td>
      <td className='data-table__cell data-table__cell--fix-md data-table__cell--minimum '>
        <div className='data-table__content'>{tel}</div>
      </td>
      <td className='data-table__cell data-table__cell--fix-md data-table__cell--minimum '>
        <div className='data-table__content'>-</div>
      </td>
      <td className='data-table__cell data-table__cell--fix-md data-table__cell--minimum '>
        <div className='data-table__content' />
      </td>
      <td className='data-table__cell data-table__cell--fix-md data-table__cell--minimum '>
        <div className='data-table__content' />
      </td>
      <td className='data-table__cell data-table__cell--fix-md data-table__cell--minimum '>
        <div className='data-table__content' />
      </td>
      {!usageMarkDisabled && (
        <td className='data-table__cell data-table__cell--fix-md data-table__cell--minimum '>
          <div className='data-table__content' />
        </td>
      )}
    </tr>
  );
};

export class ShowCheckPartnerCompanyDialog extends React.Component {
  render() {
    const getDialogMessage = () => {
      if (this.props.fromFieldTreePage) {
        return (
          <p className='dialog__text-box dialog__text'>
            上記の会社を現場体制（施工体系図）に追加します。
            <br />
            よろしいですか？
          </p>
        );
      } else if (this.props.fromPartnerCompanies) {
        return (
          <p className='dialog__text-box dialog__text'>
            上記の会社を協力会社一覧に追加します。
            <br />
            よろしいですか？
          </p>
        );
      } else if (this.props.fromAgencyRegister) {
        return (
          <p className='dialog__text-box dialog__text'>
            上記の会社を代行先として選択します。
            <br />
            よろしいですか？
          </p>
        );
      }
      return null;
    };

    const closeBtnText = () => {
      if (this.props.fromFieldTreePage || this.props.fromPartnerCompanies) {
        return messageUtility.getMessage('I-000-008');
      } else if (this.props.fromAgencyRegister) {
        return messageUtility.getMessage('I-000-123');
      } else {
        return '';
      }
    };
    const selectCompanyBtnText = () => {
      if (this.props.fromFieldTreePage || this.props.fromPartnerCompanies) {
        return '追加';
      } else if (this.props.fromAgencyRegister) {
        return '選択';
      } else {
        return '';
      }
    };

    return (
      <React.Fragment>
        {this.props.visible && (
          <CommonModal visible={this.props.visible}>
            <div className='dialog dialog--modal'>
              <div className='dialog__header'>
                <span className='dialog__title'>
                  {messageUtility.getMessage('I-000-266')}
                </span>
              </div>
              <div className='dialog__body'>
                <p className='dialog__text-box dialog__text'>
                  選択いただいた協力会社はBuildee上で以下の情報に編集されています。
                </p>
                <span className='dialog__text-box dialog__text dialog__text--large text--red--primary'>
                  {this.props.companyName}
                </span>
                <p className='dialog__text-box dialog__text text--red--primary'>
                  {this.props.companyAddress}
                  <br />
                  （法人番号：{this.props.company_number} )
                </p>
                {getDialogMessage()}
              </div>
              <div className='dialog__footer dialog__footer--horizontal'>
                <button
                  className='btn--sub'
                  onClick={e => {
                    this.props.onBack(e);
                  }}
                >
                  {closeBtnText()}
                </button>
                <button
                  className='btn--effective'
                  onClick={e => {
                    this.props.onNew(e);
                  }}
                >
                  {selectCompanyBtnText()}
                </button>
              </div>
            </div>
          </CommonModal>
        )}
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PartnerCompanyAddDialog.jsx